/**
 * TR-01 Machine-leaning lexical choices (T2-DESIGN §4.2, DESIGN CD-46, CD-51). The translation axis (outside the authorship
 * composite by axis). A paragraph's K is Σ_g w_g·log1p(count) over the 2,500 machine-leaning grams of
 * `lang/en/v3/tr-markers.json`, E its prose words; unshrunk rate per 1,000 words. The measurement, the evidence rule and
 * the strong-marker cut are in `tr-scan.ts`, shared with TR-02 (one pass scores both).
 */
import { rateChannel } from './framework.ts';
import { tr01Def } from './tr-defs.ts';
import { trScan } from './tr-scan.ts';
import type { ChannelImpl, Measurement, RunContext } from './types.ts';

const base = rateChannel(
	tr01Def,
	(ctx: RunContext): Measurement => trScan(ctx.doc).machine.measurement
);

// no `measure`: the bench has no route for the translation-axis lexical channels (routes.ts: "no de-signature route")
export const tr01: ChannelImpl = { def: base.def, phase: base.phase, run: base.run };
